// extracted by css-extract-rspack-plugin
export default {"NameAndOwnershipReviewSection":"sputnik__NameAndOwnershipReviewSection__sUmbx","nameAndOwnershipReviewSection":"sputnik__NameAndOwnershipReviewSection__sUmbx"};